import { render, staticRenderFns } from "./rcd.vue?vue&type=template&id=5f497c7c&scoped=true&"
import script from "./rcd.vue?vue&type=script&lang=js&"
export * from "./rcd.vue?vue&type=script&lang=js&"
import style0 from "./rcd.vue?vue&type=style&index=0&id=5f497c7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f497c7c",
  null
  
)

export default component.exports